import React from 'react';
import { TableCell } from '~/components/organism/Table/types';
import ActionColumnCell from '~/components/organism/Table/components/ActionColumnCell';
import useConfirmModal from '~/hooks/useConfirmModal';
import useAddToast from '~/hooks/useAddToast';
import formatToastMessage from '~/util/formatToastMessage';
import useDeleteContact from '~/hooks/useDeleteContact';

const text = {
  deleteLabel: 'Verwijderen',
  deleteErrorTitle: 'Oeps!',
  deleteErrorMessage:
    'Er is iets misgegaan bij het verwijderen van het contact. Probeer het nog eens.',
  confirmDeleteTitle: 'Contact verwijderen?',
  confirmDeleteMessage: 'Weet je zeker dat je dit contact wilt verwijderen?',
  confirmDeleteButton: 'Verwijderen',
  deleteSuccess: 'Contact is verwijderd',
};
const confirmDeleteModalText = {
  title: text.confirmDeleteTitle,
  message: text.confirmDeleteMessage,
  buttonConfirmTitle: text.confirmDeleteButton,
};

type Props = {
  contactId: string;
  cell: TableCell<any>;
  onSuccessfulDelete: () => void;
};
const ContactActionColumnCell: React.FCC<Props> = ({
  contactId,
  cell,
  onSuccessfulDelete,
}) => {
  const addToast = useAddToast();
  const { deleteContact, loading } = useDeleteContact();

  const deleteFn = async e => {
    e.stopPropagation();
    const result = await deleteContact(contactId);
    if (!result.success) {
      addToast([formatToastMessage(text.deleteErrorMessage, 'danger')]);
    } else {
      addToast([formatToastMessage(text.deleteSuccess, 'success')]);
      onSuccessfulDelete();
    }
  };

  const { setShowModal, modal } = useConfirmModal({
    labels: confirmDeleteModalText,
    buttons: [
      {
        label: confirmDeleteModalText.buttonConfirmTitle,
        onClick: deleteFn,
        loading,
      },
    ],
    level: 'danger',
  });

  return (
    <>
      <ActionColumnCell
        key={'contact-action-column-cell'}
        loading={loading}
        options={[
          {
            label: text.deleteLabel,
            onClick: () => setShowModal(true),
            key: 'delete',
            type: 'DELETE',
          },
        ]}
        cell={cell}
      />
      {modal}
    </>
  );
};

export default ContactActionColumnCell;
